import React from "react";
import ReactApexChart from "react-apexcharts";

interface ApexChartProps {
  chartData?: any[];
  nestedData?: any[];
}

const MultiLineZoomChart: React.FC<ApexChartProps> = ({
  chartData = [],
  nestedData = [],
}) => {
  // Use nestedData only if chartData is empty or not provided
  const activeData = chartData.length > 0 ? chartData : nestedData;
  const useNested = chartData.length === 0 && nestedData.length > 0;

  const options = {
    chart: {
      height: 350,
      id: "line",
    },
    stroke: {
      width: 1.5,
      curve: "smooth" as "smooth",
    },
    xaxis: {
      categories: useNested
        ? nestedData.map((data: any) => data.Date)
        : chartData.map((data) => data.Date).reverse(),
    },
    tooltip: useNested
      ? {
          shared: false,
          custom: function ({
            series,
            seriesIndex,
            dataPointIndex,
            w,
          }: {
            series: number[][];
            seriesIndex: number;
            dataPointIndex: number;
            w: any;
          }) {
            const countryName = w.globals.seriesNames[seriesIndex];
            const details = nestedData[dataPointIndex][countryName];

            const items = Object.entries(details || {})
              .filter(([key]) => key !== "total")
              .map(
                ([key, value]) =>
                  `<span style="white-space:nowrap"><b>${key}:</b> ${value}</span>`,
              )
              .join("");

            return `
            <div style="min-width:200px;max-width:360px;">
              <strong style="display:block;background:#f1f1f1;padding:4px 8px;font-size:13px">${countryName}</strong>
              <strong style="display:block;padding:4px 8px;font-weight:600;font-size:13px;border-bottom:1px solid #eee;">Total: ${
                details?.total || 0
              }</strong>
              <div style="padding:4px 8px 6px;display:grid;grid-template-columns:1fr 1fr;gap:2px 10px;font-size:11px;max-height:160px;overflow:hidden;">
                ${items}
              </div>
            </div>
          `;
          },
        }
      : {},
  };

  const series = useNested
    ? Object.keys(nestedData[0] || {})
        .filter((key) => key !== "Date")
        .map((key) => ({
          name: key,
          data: nestedData.map((data: any) => data[key]?.total || 0),
        }))
    : Object.keys(chartData[0])
        .filter((key) => key !== "Date")
        .map((key) => ({
          name: key,
          data: chartData.map((data: any) => data[key]).reverse(),
        }));

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          width="98%"
          height={350}
        />
      </div>
    </div>
  );
};

export default MultiLineZoomChart;
